import { getColorFromHex } from "~/helpers/color-helpers";
import type { Property } from "~/helpers/entities/property-helpers";

export type PropertiesEntity = {
  assetManagementProperties?: {
    items?: Property[] | null;
    metadata?: {
      totalCount?: number | null;
    };
  };
};

export type Portfolio = PropertiesEntity & {
  id: string;
  color?: string | null;
  name?: string | null;
  active?: boolean | null;
};

export const getNumberOfProperties = function (portfolio: Nullable<PropertiesEntity>) {
  return portfolio?.assetManagementProperties?.metadata?.totalCount ?? 0;
};

export const getNumberOfUnits = function (portfolio: Nullable<PropertiesEntity>) {
  return portfolio?.assetManagementProperties?.items?.reduce((acc, property) => {
    return acc + (property.assetManagementTenancies?.metadata?.totalCount ?? 0);
  }, 0);
};

export const getPortfolioColors = function () {
  return ["white", "yellow", "purple", "blue", "pink", "green", "red", "brown", "magenta", "cyan", "maroon", "autumn"];
};

export const getHexFromColor = function (color: string) {
  if (color == "white") return "#FFFFFF";

  const hex = getCssVariableValue(`--color-${color}-500`).trim();

  return hex ? hex : "#1C1C1C";
};

function getCssVariableValue(variableName: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName);
}

export function getPortfolioColorForeground(portfolio: Nullable<Portfolio>) {
  const colorHex = portfolio?.color ?? "";

  return `--color-${getColorFromHex(colorHex)}-900`;
}

export function getPortfolioColorBackground(portfolio: Nullable<Portfolio>) {
  const colorHex = portfolio?.color ?? "";

  if (getColorFromHex(colorHex) == "white") return `--color-accent-100`;

  return `--color-${getColorFromHex(colorHex)}-50`;
}

export const getTenanciesForPortfolio = (portfolio: Portfolio) =>
  portfolio.assetManagementProperties?.items?.flatMap((property) => property.assetManagementTenancies?.items ?? []) ?? [];
